module.exports = __webpack_public_path__ + "static/img/qpGame.6fab83c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/qpGame.webp
// module id = KufF
// module chunks = 3